var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.5C18 9.949 17.552 9.5 17 9.5C16.448 9.5 16 9.949 16 10.5C16 11.051 16.448 11.5 17 11.5C17.552 11.5 18 11.051 18 10.5ZM20 10.5C20 12.154 18.654 13.5 17 13.5C15.346 13.5 14 12.154 14 10.5C14 8.846 15.346 7.5 17 7.5C18.654 7.5 20 8.846 20 10.5ZM11 7.5C11 6.397 10.103 5.5 9 5.5C7.897 5.5 7 6.397 7 7.5C7 8.603 7.897 9.5 9 9.5C10.103 9.5 11 8.603 11 7.5ZM13 7.5C13 9.706 11.206 11.5 9 11.5C6.794 11.5 5 9.706 5 7.5C5 5.294 6.794 3.5 9 3.5C11.206 3.5 13 5.294 13 7.5ZM13.94 15.546C14.809 14.874 15.879 14.5 17 14.5C19.757 14.5 22 16.743 22 19.5C22 20.052 21.553 20.5 21 20.5C20.447 20.5 20 20.052 20 19.5C20 17.846 18.654 16.5 17 16.5C16.317 16.5 15.668 16.734 15.144 17.149C15.688 18.145 16 19.287 16 20.5C16 21.052 15.553 21.5 15 21.5C14.447 21.5 14 21.052 14 20.5C14 17.743 11.757 15.5 9 15.5C6.243 15.5 4 17.743 4 20.5C4 21.052 3.553 21.5 3 21.5C2.447 21.5 2 21.052 2 20.5C2 16.64 5.141 13.5 9 13.5C10.927 13.5 12.673 14.283 13.94 15.546Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.2e1f2d27a2f8c29a8be9143e5c4a7f13.svg";
export { ForwardRef as ReactComponent };